import * as PIXI from 'pixi.js';
import * as TweenJS from "slotworks/utils/tween";
import { CenterPivot, PIXIElement } from 'slotworks/graphics/pixi/group';
import { parallel } from 'slotworks/utils/race-utils';
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import { ZoomIn, ZoomOut, FadeOut, FadeIn } from "slotworks/graphics/animation/base-animations";

export default class RespinGlowTransitions extends AbstractSceneTransition {

    public in(): Contract<void> {
        return new Contract(resolve => {
            const spine = Layers.CelebrationBackground.getSpine("winmessages");
            // @ts-ignore
            spine.scale.set(1.8, 1.8);
            spine.state.setAnimation(0, "background_glow_loop", true);
            resolve(null);
        });
    }

    public out(): Contract<void> {
        const spine = Layers.CelebrationBackground.getSpine("winmessages");
        spine.state.clearTracks();
        return FadeOut(Layers.CelebrationBackground.getSprite("fullscreen"), 100);
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/respins-glow-transitions.ts